import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=1c195fa8&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=1c195fa8&prod&scoped=true&lang=css"
import style1 from "./CustomPagination.vue?vue&type=style&index=1&id=1c195fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c195fa8",
  null
  
)

export default component.exports